/* Halloween-Landingpage 2026 (ESSENZ): Countdown, Rabattcode, Slider, Filter
   und Kaufbox. Jede Section initialisiert sich über data-ez-hw selbst, auch
   nach einem Reload im Theme-Editor. Aufbau wie die Wellbe-Seite (wb-hw). */
(function () {
  if (window.EzHw) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var mobileQuery = window.matchMedia('(max-width: 989px)');
  var log = window.ezHwLog = window.ezHwLog || [];

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- Countdown ---------- */
  function globalEnd() {
    var bar = document.querySelector('.ez-hw-cbar[data-end]');
    return bar ? bar.getAttribute('data-end') : '';
  }

  function initCountdown(el) {
    var end = Date.parse(el.getAttribute('data-end') || globalEnd());
    if (isNaN(end)) return;
    var units = {};
    el.querySelectorAll('[data-unit]').forEach(function (u) {
      (units[u.getAttribute('data-unit')] = units[u.getAttribute('data-unit')] || []).push(u);
    });
    function set(key, value) { (units[key] || []).forEach(function (u) { u.textContent = value; }); }
    function tick() {
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      set('d', pad(Math.floor(left / 86400)));
      set('h', pad(Math.floor(left % 86400 / 3600)));
      set('m', pad(Math.floor(left % 3600 / 60)));
      set('s', pad(left % 60));
      if (left === 0) clearInterval(timer);
    }
    var timer = setInterval(tick, 1000);
    tick();
  }

  /* Die Leiste steht im Template unter dem Header, Figma zeigt sie darüber.
     Sie kommt vor die Header-Gruppe, damit sie nicht mitklebt. Die grüne
     Ankündigungsleiste des Themes fehlt im Figma und wird ausgeblendet. */
  function initTopbar(el) {
    if (el.getAttribute('data-hide-announcement') === 'true') document.documentElement.classList.add('ez-hw-no-announcement');
    if (designMode || el.getAttribute('data-above-header') !== 'true') return;
    var section = el.closest('.shopify-section');
    var header = document.getElementById('header-group');
    if (section && header && header.parentNode) header.parentNode.insertBefore(section, header);
  }

  /* ---------- Rabattcode beim Seitenaufruf vormerken ---------- */
  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function rememberCode(code) {
    if (!code || readCookie('discount_code').toUpperCase() === code.toUpperCase()) {
      log.push('code bereits gesetzt');
      return;
    }
    var url = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart.js') + '&_=' + Date.now();
    fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(function () {
        if (readCookie('discount_code').toUpperCase() === code.toUpperCase()) { log.push('gesetzt via fetch'); return; }
        throw new Error('cookie fehlt');
      })
      .catch(function () {
        var img = new Image();
        img.onerror = img.onload = function () { log.push('gesetzt via Bild: ' + (readCookie('discount_code') || 'leer')); };
        img.src = url + '1';
      });
  }

  function initAutocode(el) {
    if (designMode || el.getAttribute('data-autocode') !== 'true') return;
    rememberCode(el.getAttribute('data-code'));
  }

  /* ---------- Code kopieren ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ez-hw-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-ez-hw-copy');
    function done() {
      btn.classList.add('is-copied');
      setTimeout(function () { btn.classList.remove('is-copied'); }, 1600);
    }
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(ta);
      done();
    }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, fallback);
    else fallback();
  });

  /* ---------- Scroll-Slider (Kreise, Produkt-Slider, Bewertungen) ---------- */
  function initCarousel(el) {
    var track = el.querySelector('[data-ez-hw-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dotsWrap = el.querySelector('[data-ez-hw-dots]');
    var prevs = el.querySelectorAll('[data-ez-hw-prev]');
    var nexts = el.querySelectorAll('[data-ez-hw-next]');

    function step() {
      if (slides.length < 2) return track.clientWidth;
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }
    /* Eine Seite = so viele Karten, wie samt Abstand vollständig in den Track passen. */
    function perView() {
      var gap = slides.length > 1 ? step() - slides[0].offsetWidth : 0;
      return Math.max(1, Math.floor((track.clientWidth + gap + 2) / step()));
    }
    function pages() { return Math.max(1, Math.ceil((slides.length - perView()) / perView()) + 1); }
    function current() {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 2) return 0;
      if (track.scrollLeft >= max - 2) return pages() - 1;
      return Math.round(track.scrollLeft / (step() * perView()));
    }
    function go(page) {
      var n = pages();
      var p = ((page % n) + n) % n;
      track.scrollTo({ left: p * perView() * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function renderDots() {
      var n = pages();
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Seite ' + (i + 1));
          b.addEventListener('click', go.bind(null, i));
          dotsWrap.appendChild(b);
        }
        dotsWrap.hidden = n < 2;
      }
    }
    function update() {
      var c = current();
      if (dotsWrap) dotsWrap.querySelectorAll('button').forEach(function (d, i) { d.classList.toggle('is-active', i === c); });
    }
    prevs.forEach(function (b) { b.addEventListener('click', function () { go(current() - 1); restart(); }); });
    nexts.forEach(function (b) { b.addEventListener('click', function () { go(current() + 1); restart(); }); });
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', function () { renderDots(); update(); });
    renderDots();
    update();

    var timer = null;
    var paused = false;
    var autoplay = el.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(el.getAttribute('data-interval'), 10) || 5000;
    function restart() {
      if (!autoplay || reduceMotion) return;
      clearInterval(timer);
      timer = setInterval(function () { if (!paused) go(current() + 1); }, interval);
    }
    if (autoplay) {
      ['mouseenter', 'touchstart', 'focusin'].forEach(function (ev) { el.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      ['mouseleave', 'touchend', 'focusout'].forEach(function (ev) { el.addEventListener(ev, function () { paused = false; }, { passive: true }); });
      restart();
    }
  }

  /* ---------- Endlos-Karussell (Bewertungen) ----------
     Vor und hinter die echten Karten kommt je eine Kopie des Satzes. Landet
     der Scroll in einer Kopie, springt er unsichtbar um genau einen Satz
     zurück. So läuft es in beide Richtungen ohne Rücksprung durch. */
  function initLoop(el) {
    var track = el.querySelector('[data-ez-hw-track]');
    if (!track) return;
    var real = Array.prototype.slice.call(track.children);
    var n = real.length;
    if (n < 2) return;
    function clone(node) {
      var c = node.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('data-shopify-editor-block');
      c.querySelectorAll('a, button').forEach(function (x) { x.setAttribute('tabindex', '-1'); });
      return c;
    }
    real.forEach(function (node) { track.appendChild(clone(node)); });
    for (var i = n - 1; i >= 0; i--) track.insertBefore(clone(real[i]), track.firstChild);

    function step() { return track.children[1].offsetLeft - track.children[0].offsetLeft; }
    function setSize() { return n * step(); }
    function jump(delta) {
      track.style.scrollSnapType = 'none';
      track.scrollLeft += delta;
      void track.offsetWidth;
      track.style.scrollSnapType = '';
    }
    function home() { track.scrollLeft = 0; jump(setSize()); }
    function normalize() {
      var set = setSize();
      if (track.scrollLeft < set - step() / 2) jump(set);
      else if (track.scrollLeft >= 2 * set - step() / 2) jump(-set);
    }
    var settle;
    track.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(normalize, 140);
    }, { passive: true });
    function go(dir) {
      normalize();
      track.scrollBy({ left: dir * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    el.querySelectorAll('[data-ez-hw-prev]').forEach(function (b) { b.addEventListener('click', function () { go(-1); }); });
    el.querySelectorAll('[data-ez-hw-next]').forEach(function (b) { b.addEventListener('click', function () { go(1); }); });
    window.addEventListener('resize', function () { clearTimeout(settle); settle = setTimeout(normalize, 140); });
    home();
  }

  /* ---------- Produktfilter mit „Alle Produkte ansehen“ ---------- */
  function initProducts(el) {
    var cards = el.querySelectorAll('.ez-hw-card');
    var tabs = el.querySelectorAll('.ez-hw-tab');
    var more = el.querySelector('[data-ez-hw-more]');
    var cat = '';
    var expanded = false;
    function limit() {
      return parseInt(el.getAttribute(mobileQuery.matches ? 'data-limit-mobile' : 'data-limit'), 10) || 8;
    }
    function apply() {
      var shown = 0;
      var matching = 0;
      /* Die Begrenzung gilt nur für „Alle Produkte“, eine Kategorie zeigt immer alles. */
      var max = expanded || cat ? Infinity : limit();
      cards.forEach(function (card) {
        var cats = (card.getAttribute('data-cats') || '').split(',');
        var match = !cat || cats.indexOf(cat) !== -1;
        if (match) matching++;
        var show = match && shown < max;
        if (show) shown++;
        card.hidden = !show;
      });
      if (more) more.parentNode.hidden = shown >= matching;
    }
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        cat = tab.getAttribute('data-cat');
        expanded = false;
        apply();
      });
    });
    if (more) more.addEventListener('click', function () { expanded = true; apply(); });
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', apply);
    apply();
  }

  /* ---------- Warenkorb des Themes (KondaSoft, Bootstrap-Offcanvas) ---------- */
  var CART_SECTIONS = ['cart-count-badge', 'offcanvas-cart'];

  function postJSON(url, body) {
    return fetch(root + url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data && data.description || 'cart');
        return data;
      });
    });
  }

  function showCart(sections) {
    var container = document.querySelector('cart-container');
    if (container && sections && typeof container.reloadCartElements === 'function') {
      container.reloadCartElements(sections);
    }
    var offcanvas = document.getElementById('offcanvas-cart');
    if (offcanvas && window.bootstrap && window.bootstrap.Offcanvas) {
      window.bootstrap.Offcanvas.getOrCreateInstance(offcanvas).show();
    } else {
      window.location.href = root + 'cart';
    }
  }

  /* Hängt den Code an den Warenkorb, ohne fremde Codes zu verlieren
     (/cart/update.js ersetzt sonst die Liste). */
  function applyCode(code) {
    return fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var codes = (cart.discount_codes || [])
          .filter(function (d) { return d.applicable && d.code.toUpperCase() !== code.toUpperCase(); })
          .map(function (d) { return d.code; });
        codes.push(code);
        return postJSON('cart/update.js', { discount: codes.join(','), sections: CART_SECTIONS, sections_url: window.location.pathname });
      });
  }

  /* ---------- Kaufbox ---------- */
  function initOffer(el) {
    var panels = el.querySelectorAll('.ez-hw-offer__panel');
    var images = el.querySelectorAll('.ez-hw-offer__image');
    var dots = el.querySelectorAll('.ez-hw-offer__dot');
    var button = el.querySelector('[data-ez-hw-buy]');
    var error = el.querySelector('.ez-hw-offer__error[role="alert"]');
    var code = el.getAttribute('data-code') || '';
    var count = panels.length;
    var index = 0;
    var POS = ['is-center', 'is-next', 'is-prev', 'is-far-left', 'is-far-right'];

    function show(i) {
      if (!count) return;
      index = ((i % count) + count) % count;
      panels.forEach(function (p, n) { p.classList.toggle('is-active', n === index); });
      images.forEach(function (img, n) {
        /* Ringförmig gerechnet, damit es vom letzten zum ersten Produkt ohne
           Rücklauf weitergeht (wie wb-hw). */
        var o = (n - index + count) % count;
        if (o > count / 2) o -= count;
        POS.forEach(function (c) { img.classList.remove(c); });
        if (o === 0) img.classList.add('is-center');
        else if (o === 1) img.classList.add('is-next');
        else if (o === -1) img.classList.add('is-prev');
        else if (o < 0) img.classList.add('is-far-left');
        else img.classList.add('is-far-right');
        img.setAttribute('aria-hidden', o === 0 ? 'false' : 'true');
      });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
      if (error) error.classList.remove('is-visible');
    }

    el.querySelectorAll('[data-ez-hw-prev]').forEach(function (b) { b.addEventListener('click', function () { show(index - 1); }); });
    el.querySelectorAll('[data-ez-hw-next]').forEach(function (b) { b.addEventListener('click', function () { show(index + 1); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-slide'), 10)); }); });

    var stage = el.querySelector('.ez-hw-offer__images');
    var startX = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
        startX = null;
      }, { passive: true });
    }

    panels.forEach(function (panel) {
      var packs = panel.querySelectorAll('.ez-hw-pack');
      function select(pack) { packs.forEach(function (p) { p.classList.toggle('is-selected', p === pack); }); }
      packs.forEach(function (pack) {
        var input = pack.querySelector('input');
        if (input) input.addEventListener('change', function () { select(pack); });
      });
      var checked = panel.querySelector('.ez-hw-pack__input:checked');
      if (checked) select(checked.closest('.ez-hw-pack'));
      else if (packs.length) {
        packs[0].querySelector('input').checked = true;
        select(packs[0]);
      }
    });

    show(0);

    /* Von außen ansteuerbar: Links mit data-ez-hw-offer="<handle>" wählen das
       Produkt vor und scrollen zur Kaufbox. */
    el.__ezHwSelect = function (handle) {
      for (var n = 0; n < panels.length; n++) {
        if (panels[n].getAttribute('data-product') === handle) { show(n); return true; }
      }
      return false;
    };

    if (!button) return;
    button.addEventListener('click', function () {
      var input = panels[index] && panels[index].querySelector('.ez-hw-pack__input:checked');
      var variantId = input ? parseInt(input.value, 10) : 0;
      if (!variantId) {
        if (error) error.classList.add('is-visible');
        return;
      }
      button.disabled = true;
      button.classList.add('is-loading');
      postJSON('cart/add.js', { items: [{ id: variantId, quantity: 1 }], sections: CART_SECTIONS, sections_url: window.location.pathname })
        .then(function (data) {
          window.dispatchEvent(new CustomEvent('kt.cart.added', { detail: data }));
          if (!code) return data;
          return applyCode(code).catch(function () { return data; });
        })
        .then(function (data) { showCart(data && data.sections); })
        .catch(function () { if (error) error.classList.add('is-visible'); })
        .finally(function () {
          button.disabled = false;
          button.classList.remove('is-loading');
        });
    });
  }

  /* ---------- Lagerhinweis „Nur noch … auf Lager“ ----------
     Startet je Produkt knapp unter dem Startwert und sinkt Tag für Tag um einen
     je Produkt und Tag unterschiedlichen Betrag. Berechnet aus Produkt-Handle
     und Datum, damit alle Besucher am selben Tag dieselbe Zahl sehen und beide
     Raster auf der Seite übereinstimmen. */
  function hash(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }

  function stockFor(el) {
    var key = el.getAttribute('data-ez-hw-stock') || '';
    var start = parseInt(el.getAttribute('data-start'), 10) || 500;
    var min = parseInt(el.getAttribute('data-drop-min'), 10) || 6;
    var max = Math.max(min, parseInt(el.getAttribute('data-drop-max'), 10) || 18);
    var floor = parseInt(el.getAttribute('data-floor'), 10) || 37;
    var startDay = Date.parse((el.getAttribute('data-start-date') || '') + 'T00:00:00+01:00');
    var value = start - hash(key) % 25;
    if (!isNaN(startDay)) {
      var days = Math.floor((Date.now() - startDay) / 86400000);
      for (var d = 1; d <= days; d++) value -= min + hash(key + ':' + d) % (max - min + 1);
    }
    return Math.max(floor, value);
  }

  function initStock(scope) {
    (scope || document).querySelectorAll('[data-ez-hw-stock]').forEach(function (el) {
      el.textContent = stockFor(el);
    });
  }

  /* ---------- Sprung zur Kaufbox mit vorausgewähltem Produkt ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-ez-hw-offer]');
    if (!link) return;
    var offer = document.querySelector('[data-ez-hw~="offer"]');
    if (!offer) return;
    e.preventDefault();
    if (offer.__ezHwSelect) offer.__ezHwSelect(link.getAttribute('data-ez-hw-offer'));
    offer.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- Direkt in den Warenkorb (Produkte ohne Kaufbox) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ez-hw-add]');
    if (!btn) return;
    e.preventDefault();
    /* Bild und Name sind Links ohne disabled, deshalb zusätzlich über is-loading sperren. */
    if (btn.disabled || btn.classList.contains('is-loading')) return;
    var id = parseInt(btn.getAttribute('data-ez-hw-add'), 10);
    var scope = btn.closest('[data-code]');
    var code = scope ? scope.getAttribute('data-code') : '';
    btn.disabled = true;
    btn.classList.add('is-loading');
    postJSON('cart/add.js', { items: [{ id: id, quantity: 1 }], sections: CART_SECTIONS, sections_url: window.location.pathname })
      .then(function (data) {
        window.dispatchEvent(new CustomEvent('kt.cart.added', { detail: data }));
        if (!code) return data;
        return applyCode(code).catch(function () { return data; });
      })
      .then(function (data) { showCart(data && data.sections); })
      .catch(function () { window.location.href = root + 'cart/add?id=' + id + '&quantity=1'; })
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });

  var inits = {
    countdown: initCountdown,
    topbar: initTopbar,
    autocode: initAutocode,
    carousel: initCarousel,
    loop: initLoop,
    products: initProducts,
    offer: initOffer
  };

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ez-hw]').forEach(function (el) {
      if (el.__ezHw) return;
      el.__ezHw = true;
      el.getAttribute('data-ez-hw').split(' ').forEach(function (name) {
        if (inits[name]) inits[name](el);
      });
    });
  }

  window.EzHw = { init: initAll };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); initStock(); });
  else { initAll(); initStock(); }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); initStock(e.target); });
})();
